
import { Options, Vue } from "vue-class-component";
import store from "@/store";
import { Analysis, SupportingDocumentStatus } from "@/types";
import { Store } from "vuex";
@Options({
  props: ["qualificationType", "role"],
  data() {
    return {
      itemText: '',
    };
  },
  watch: {
    qualificationType: {
      immediate: true,
      handler() {
        // @ts-ignore
        this.loadFromStore();
      },
    },
    role: {
      immediate: true,
      handler() {
        // @ts-ignore
        this.loadFromStore();
      },
    },
    opinionQualifications: {
      deep: true,
      handler() {
        // @ts-ignore
        this.loadFromStore();
      },
    },
  },
})
export default class Comment extends Vue {
  qualification?: Analysis;
  qualificationType: any;
  opinionQualificationsModel: any;
  role?: any;

  itemText!: string;

  loadFromStore() {
    const item = this.opinionQualifications?.find(
        (it: any) =>
            it?.qualificationType?.resourceUid === this.qualificationType
    );

    const storeValue = item?.comment ?? "";

    if (this.itemText !== storeValue) {
      this.itemText = storeValue;
    }
  }

  onCommentChange(newValue: string) {
    const index = this.opinionQualifications?.findIndex(
        (it: any) =>
            it?.qualificationType?.resourceUid === this.qualificationType
    );

    if (index !== -1 && index !== undefined) {
      this.$store.commit("taskModule/analysisModule/setComment", {
        index,
        text: newValue,
      });
    }
  }

  get opinionQualifications() {
    return store.getters["taskModule/analysisModule/getOpinionQualifications"];
  }
  get analysisSections() {
    return store.getters["taskModule/analysisModule/analysisSections"];
  }

  get isAnalysisSection() {
    return this.analysisSections.includes(this.qualificationType);
  }
}
